// extracted by mini-css-extract-plugin
export default {"root":"Map_root__TSprR","mapRoot":"Map_mapRoot__xK+Jl"};